import type { NewUserQuizCopy } from '../types';

export const IT_NEW_USER_QUIZ_COPY = {
  booking: {
    bookedSnackbar: 'La tua demo è prenotata — a presto!',
    bullets: {
      pricing: 'Prezzi chiari in base al volume e al livello di assistenza',
      teams: 'Pensato per i team: revisori, glossari e un’unica libreria',
      setup: 'Scopri la configurazione giusta per i tuoi contenuti e il tuo flusso di lavoro',
    },
    description: 'Scopri come Rask mantiene identità, intento e contesto in tutte le lingue.',
    heading: 'Scopri come Rask si adatta al tuo flusso di lavoro',
    headingSecondLine: 'Prenota una demo: guarda Rask in azione',
    maybeLater: 'Forse più tardi',
    rating: '4,7/5 su G2',
    scheduler: {
      openBookingPage: 'Apri la pagina di prenotazione',
      loadErrorDescription:
        'La tua rete o la tua area geografica potrebbe bloccare il contenuto incorporato. Apri invece la pagina di prenotazione in una nuova scheda.',
      loadErrorTitle: 'Impossibile caricare il calendario',
      loadingLabel: 'Caricamento del calendario',
    },
    trustedBy: 'Scelto da team in tutto il mondo',
  },
  controls: {
    back: 'Indietro',
    continue: 'Continua',
    continueAnyway: 'Continua comunque',
    progress: (currentStep, totalSteps) => `Domanda ${currentStep} di ${totalSteps}`,
    submitError: 'Non è stato possibile salvare le tue risposte. Riprova.',
  },
  priorityQuestion: {
    title: 'Cosa conta di più per te nella localizzazione dei video?',
    options: {
      collaborate_with_team_or_reviewers: { label: 'Collaborazione con il team o i revisori' },
      consistent_voice_and_terminology: { label: 'Voce e terminologia coerenti' },
      fast_results_no_setup: { label: 'Risultati rapidi, senza configurazione' },
      integration_into_product_or_workflow: { label: 'Integrazione nel nostro prodotto o flusso di lavoro' },
      not_sure_yet: { label: 'Non lo so ancora' },
    },
    subtitle: 'Seleziona tutte le opzioni applicabili',
  },
  questions: {
    content_team_size: {
      title: 'Quanto è grande il tuo team di contenuti?',
      options: {
        just_me: { label: 'Solo io' },
        large_team_5_plus: { label: 'Un team numeroso', description: '5 o più persone' },
        small_team_2_5: { label: 'Un piccolo team', description: 'Da 2 a 5 persone' },
      },
    },
    localization_frequency: {
      title: 'Con quale frequenza traduci, doppi o localizzi video?',
      options: {
        continuously: { label: 'Continuamente', description: 'Flusso di lavoro continuo' },
        occasionally_quarterly: { label: 'Occasionalmente', description: 'Circa una volta a trimestre' },
        regularly_monthly: { label: 'Regolarmente', description: 'Ogni mese' },
        one_time_project: { label: 'Progetto una tantum', description: 'Un singolo progetto, non continuativo' },
      },
    },
    localized_videos_before: {
      title: 'Hai già localizzato dei video?',
      options: {
        false: { label: 'No' },
        true: { label: 'Sì' },
      },
      subtitle: 'Alcune brevi domande per personalizzare la tua esperienza',
    },
    target_language_count: {
      title: 'In quante lingue vuoi localizzare i tuoi video?',
      options: {
        changes_by_project: { label: 'Varia in base al progetto', description: 'Nessun numero fisso' },
        four_to_ten: { label: '4 – 10', description: 'Più mercati contemporaneamente' },
        ten_plus: { label: '10+', description: 'Lancio ampio e su larga scala' },
        two_to_three: { label: '2 – 3', description: 'Un paio di mercati' },
        one: { label: '1', description: 'Una sola lingua' },
      },
    },
  },
} satisfies NewUserQuizCopy;
